import resellerBusinessService from "../services/partner/reseller/business";
import whitelabelBusinessService from "../services/partner/whitelabel/business";

export default {
    namespaced: true,
    state: {
        customerEmail: null,
        customerBusinessList: [],
        customerBusinessListWaiting: false,
        customerBusinessListError: null,
    },
    getters: {
        customerEmail: (state) => state.customerEmail,
        customerBusinessList: (state) => state.customerBusinessList,
        customerBusinessListWaiting: (state) => state.customerBusinessListWaiting,
        customerBusinessListError: (state) => state.customerBusinessListError,
    },
    mutations: {
        setCustomerBusinessList(state, businessList) {
            state.customerBusinessListWaiting = false
            state.customerBusinessList = businessList
            state.customerBusinessListError = null
        },
        setCustomerBusinessListError(state, message) {
            state.customerBusinessListWaiting = false
            state.customerBusinessListError = message
        }
    },
    actions: {
        async fetchBusinessesFromEmail({ state, commit, rootGetters }, email) {
            const activeAccount = rootGetters["partner/active"];
            state.customerBusinessListWaiting = true;
            try {
                if (!activeAccount.id) throw new Error("Bad State");
                state.email = email
                let businesses = [];
                if(rootGetters["partner/active"].type == "whitelabel")
                    businesses = await whitelabelBusinessService.getWhitelabelBusinessesByEmail(email, activeAccount.id);
                else if(rootGetters["partner/active"].type == "reseller")
                    businesses = await resellerBusinessService.getResellerBusinessesByEmail(email, activeAccount.id);
                commit("setCustomerBusinessList", businesses);
            } catch (error) {
                console.error(error);
                commit("setCustomerBusinessListError", error.message);
            }
        },
    },
}